export default __webpack_public_path__ + "static/media/contact-book.b4a843f8.jpg";